// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3mYMQ","button":"styles_button__fDbtk","content":"styles_content__VEh0F"};